import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "mb-10" }
const _hoisted_7 = { class: "ms-2" }
const _hoisted_8 = { class: "mb-10" }
const _hoisted_9 = { class: "ms-2" }
const _hoisted_10 = { class: "mb-10" }
const _hoisted_11 = { class: "ms-2" }
const _hoisted_12 = { class: "mb-10" }
const _hoisted_13 = { class: "mb-10" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "mb-10" }
const _hoisted_17 = { class: "ms-2" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "mb-10" }
const _hoisted_20 = { class: "ms-2" }
const _hoisted_21 = { class: "mb-10" }
const _hoisted_22 = { class: "ms-2" }
const _hoisted_23 = { class: "mb-10" }
const _hoisted_24 = { class: "ms-2" }
const _hoisted_25 = { class: "mb-10" }
const _hoisted_26 = { class: "mb-10" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = { class: "mb-10" }
const _hoisted_30 = { class: "ms-2" }
const _hoisted_31 = { class: "mb-10" }
const _hoisted_32 = { class: "ms-2" }
const _hoisted_33 = {
  key: 1,
  class: "text-center text-danger fs-md-12"
}
const _hoisted_34 = { class: "row" }
const _hoisted_35 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_36 = { class: "table table-bordered table-sm" }
const _hoisted_37 = {
  colspan: "2",
  class: "text-center",
  style: {"background-color":"#28a745","color":"white"}
}
const _hoisted_38 = {
  colspan: "2",
  class: "text-center",
  style: {"background-color":"#0a59a4","color":"white"}
}
const _hoisted_39 = {
  colspan: "2",
  class: "text-center",
  style: {"background-color":"#dc3545","color":"white"}
}
const _hoisted_40 = { class: "fw-semibold text-center" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
        _createElementVNode("h5", { class: "text-black fw-semibold mb-0" }, "Détails de l'ouverture à la fermeture")
      ], -1)),
      _createVNode(_component_router_link, {
        to: "/OuverturesFermetures",
        class: "btn btn-primary text-black"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Retour à la liste")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.selectedOuvFer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("h6", { class: "fw-bold mb-15" }, "Informations d'ouverture", -1)),
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("strong", { class: "text-black" }, "Caisse :", -1)),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.selectedOuvFer.caisse?.nom || 'N/A'), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("strong", { class: "text-black" }, "Date d'ouverture :", -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.format_date(_ctx.selectedOuvFer.dateOuverture)), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[4] || (_cache[4] = _createElementVNode("strong", { class: "text-black" }, " Fonds de caisse initial :", -1)),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.selectedOuvFer.fondsRoulement) + " FCFA", 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[5] || (_cache[5] = _createElementVNode("strong", { class: "text-black" }, "Personnes présentes lors de l'ouverture:", -1)),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOuvFer?.personneOuverture, (billetage, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "container m-1"
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(billetage?.user?.nom) + " " + _toDisplayString(billetage?.user?.prenom), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[6] || (_cache[6] = _createElementVNode("strong", { class: "text-black" }, "Observation :", -1)),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.selectedOuvFer.observations || 'Aucune'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[15] || (_cache[15] = _createElementVNode("h6", { class: "fw-bold mb-15" }, "Informations de fermeture", -1)),
              _createElementVNode("div", _hoisted_19, [
                _cache[8] || (_cache[8] = _createElementVNode("strong", { class: "text-black" }, "Date de fermeture :", -1)),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.format_date(_ctx.selectedOuvFer.dateFin) || 'Non fermée'), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[9] || (_cache[9] = _createElementVNode("strong", { class: "text-black" }, "Solde physique :", -1)),
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.selectedOuvFer.solde || 0) + " FCFA", 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[10] || (_cache[10] = _createElementVNode("strong", { class: "text-black" }, "Solde théorique :", -1)),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.selectedOuvFer.stockTheorique || 0) + " FCFA", 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[11] || (_cache[11] = _createElementVNode("strong", { class: "text-black" }, "Écart :", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["ms-2", { 'text-danger': _ctx.selectedOuvFer.ecart < 0 }])
                }, _toDisplayString(_ctx.selectedOuvFer.ecart || 0) + " FCFA ", 3)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[12] || (_cache[12] = _createElementVNode("strong", { class: "text-black" }, "Personnes présentes Fermeture:", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOuvFer?.personneFermeture, (billetage, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "container m-1"
                  }, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(billetage?.user?.nom) + " " + _toDisplayString(billetage?.user?.prenom), 1)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[13] || (_cache[13] = _createElementVNode("strong", { class: "text-black" }, "Observations :", -1)),
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.selectedOuvFer.observationsFin || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[14] || (_cache[14] = _createElementVNode("strong", { class: "text-black" }, "Reliquat à retourner :", -1)),
                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.selectedOuvFer?.reliquatTotalRetourner || '0'), 1)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_33, " Chargement des détails en cours... ")),
      _createElementVNode("div", _hoisted_34, [
        (_ctx.selectedOuvFer?.billetageOuvertures?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("table", _hoisted_36, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _cache[16] || (_cache[16] = _createElementVNode("th", {
                      rowspan: "2",
                      class: "text-center align-middle",
                      style: {"background-color":"#f8f9fa"}
                    }, " Monnaie ", -1)),
                    _createElementVNode("th", _hoisted_37, " Billetage Ouverture — Total : " + _toDisplayString(_ctx.sommes(_ctx.selectedOuvFer?.billetageOuvertures)) + " FCFA ", 1),
                    _createElementVNode("th", _hoisted_38, " Billetage Fermeture — Total : " + _toDisplayString(_ctx.sommes(_ctx.selectedOuvFer?.billetageFermetures)) + " FCFA ", 1),
                    _createElementVNode("th", _hoisted_39, " Écart — Total : " + _toDisplayString(_ctx.sommes(_ctx.selectedOuvFer?.billetageEcarts)) + " FCFA ", 1)
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "text-center" }, "Quantité"),
                    _createElementVNode("th", { class: "text-center" }, "Montant"),
                    _createElementVNode("th", { class: "text-center" }, "Quantité"),
                    _createElementVNode("th", { class: "text-center" }, "Montant"),
                    _createElementVNode("th", { class: "text-center" }, "Quantité"),
                    _createElementVNode("th", { class: "text-center" }, "Montant")
                  ], -1))
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOuvFer?.billetageOuvertures, (billetage, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_40, _toDisplayString(billetage.libelle), 1),
                      _createElementVNode("td", _hoisted_41, _toDisplayString(billetage.qteBillet), 1),
                      _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.separateur(billetage.montant)), 1),
                      _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.selectedOuvFer?.billetageFermetures?.[index]?.qteBillet ?? 0), 1),
                      _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.separateur(_ctx.selectedOuvFer?.billetageFermetures?.[index]?.montant ?? 0)), 1),
                      _createElementVNode("td", {
                        class: _normalizeClass(["text-center", { 'text-danger': (_ctx.selectedOuvFer?.billetageEcarts?.[index]?.qteBillet ?? 0) < 0 }])
                      }, _toDisplayString(_ctx.selectedOuvFer?.billetageEcarts?.[index]?.qteBillet ?? 0), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["text-center", { 'text-danger': (_ctx.selectedOuvFer?.billetageEcarts?.[index]?.montant ?? 0) < 0 }])
                      }, _toDisplayString(_ctx.separateur(_ctx.selectedOuvFer?.billetageEcarts?.[index]?.montant ?? 0)), 3)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}